import React, {useEffect, useState} from 'react'
import PaperComponent from "../../components/MuiDraggableDialog";
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    FormControl,
    FormHelperText
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";
import MDBox from "../../components/MDBox";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import * as yup from "yup";
import {useTranslation} from "react-i18next";
import Grid from "@mui/material/Grid";
import MDInput from "../../components/MDInput";
import Avatar from "@mui/material/Avatar";
import Autocomplete from "@mui/material/Autocomplete";
import MDTypography from "../../components/MDTypography";
import Card from "@mui/material/Card";
import AddressGrid from "./AddressGrid";
import MDButton from "../../components/MDButton";
import Button from "@mui/material/Button";
import * as PropTypes from "prop-types";
import AddressAdd from "./AddressAdd";
import {useDispatch, useSelector} from "react-redux";
import {Logout, onErrorAlert, onSuccessAlert} from "../../actions";
import FramerFade from "../../components/Animation/Fade";
import {noop} from "lodash";
import {addCustomer, check_customer_id, customerInfo, editCustomer} from "../../actions/customer/customerAction";
import LocalStorage from "../../utils/LocalStorage";
import {useNavigate} from "react-router-dom";
import {check_product_sku, customerFilter, kitFilter, ownerSelected} from "../../actions/inventory/inventoryAction";
import Tooltip from "@mui/material/Tooltip";
import {useDebounce} from "use-debounce";
import {checkPermission, PERMISSION_DICT} from "../../utils/Users_Roles_Permission";
import { v4 as uuidv4 } from 'uuid';

Button.propTypes = {
    type: PropTypes.string,
    children: PropTypes.node
};

const CustomerEditor = ({isOpen, setIsOpen, type = 'Add', setType, data = {}, pageFormData={}, pageLoading ,setPageLoading,setTotal,setList}) => {
    const {t} = useTranslation()
    const activeArr = [
        {
            id: 1,
            value: 'Y',
            label: `${t(`ProductPage.OPEN`)}`
        },
        {
            id: 2,
            value: 'N',
            label: `${t(`ProductPage.CLOSED`)}`
        },
        {
            id: 3,
            value: 'C',
            label: `${t(`ProductPage.CREATED`)}`
        },

    ]
    const [isActive, setIsActive] = useState(activeArr[0])
    const [addresses,setAddresses] = useState([])
    const [isAddressOpen,setIsAddressOpen] = useState(false)
    const darkMode = useSelector(state => state?.common?.darkMode,(prev, next) => prev === next)
    const [currentAddress,setCurrentAddress] = useState(null)
    const [mode,setMode] = useState('Add')//for address
    const dispatch = useDispatch()
    const nav = useNavigate()
    const [loading,setLoading] = useState(false)
    const [showToolBar, setShowToolBar] = useState(false)
    const [ownerList ,setOwnerList] =useState([])
    const [ownerId, setOwnerId] = useState(null)
    const [inputOwnerValue,setInputOwnerValue] = useState()
    const [ownerValue] = useDebounce(inputOwnerValue, 500);
    const [customerId, setCustomerId] = useState('')
    const [valueCustomerId] = useDebounce(customerId, 500);
    const [loadingButtonState,setLoadingButtonState] = useState(false)
    const [customerIdError,setCustomerIdError]= useState(false)
    useEffect(()=>{
        if(ownerValue){
            const axiosPost = async () => {
                await dispatch(ownerSelected({condition: ownerValue, userName: LocalStorage.getItem('username')}, (data)=>setOwnerList(data)))
            }
            axiosPost().then()
        } else {
            setOwnerList([])
        }
    },[ownerValue])

    const onCustomerIdCheckSuccess = (flag) => {
        if (!flag && type!=='Edit') {
            setCustomerIdError(true)
            setError("customerId", {type: "Sku_Exist", message: t('CustomerPage.Customer ID existed, please change another one')})
        }
        else {
            setCustomerIdError(false)
            clearErrors('customerId')
        }
    }

    useEffect(() => {

        if(checkPermission(PERMISSION_DICT.QueryOwnerInfo) && type !== 'Preview'){
            clearErrors('owner')
            if(ownerId && customerId !=='' && customerId !== null && customerId !== undefined) {
                const axiosPost = async () => {

                    await dispatch(check_customer_id({
                        customerId: valueCustomerId,
                        ownerId: ownerId?.ownerId
                    }, onCustomerIdCheckSuccess,onError))
                }
                axiosPost().then()
            } else {
                // setCustomerId('')
                // clearErrors('sku')
            }
        }
    }, [ownerId])

    useEffect(() => {
        if(checkPermission(PERMISSION_DICT.QueryOwnerInfo) && type !== 'Preview'){
            clearErrors('owner')
            if(ownerId && valueCustomerId !=='' && valueCustomerId !== null && valueCustomerId !== undefined) {
                const axiosPost = async () => {

                    await dispatch(check_customer_id({
                        customerId: valueCustomerId,
                        ownerId: ownerId?.ownerId
                    }, onCustomerIdCheckSuccess,onError))
                }
                axiosPost().then()
            } else {
                // setCustomerId('')
                // clearErrors('sku')
            }
        }

        if(!checkPermission(PERMISSION_DICT.QueryOwnerInfo) && type !== 'Preview'){
            clearErrors('owner')
            if(valueCustomerId !=='' && valueCustomerId !== null && valueCustomerId !== undefined) {
                const axiosPost = async () => {

                    await dispatch(check_customer_id({
                        customerId: valueCustomerId,
                        ownerId: LocalStorage.getItem('ownerId'),
                    }, onCustomerIdCheckSuccess,onError))
                }
                axiosPost().then()
            } else {
                // setCustomerId('')
                // clearErrors('sku')
            }
        }
    },[valueCustomerId])


    const schema = yup
        .object({
            customerId: yup.string()
                .required(t("Required"))
                .matches(/^[^\s].*[^\s]$/, t('CustomerPage.No leading or trailing spaces allowed.'))
                .min(4,t('CustomerPage.Customer Name must contain 4 or more characters'))
                .max(32,t('CustomerPage.Customer Name must equal or less than 32 characters')),
            customerName: yup.string()
                .required(t("Required"))
                .matches(/^[^\s].*[^\s]$/, t('CustomerPage.No leading or trailing spaces allowed.'))
                .min(4,t('CustomerPage.Customer Name must contain 4 or more characters'))
                .max(32,t('CustomerPage.Customer Name must equal or less than 32 characters')),
            isActive: yup.string(),


        })

    const {
        register,
        reset,
        trigger,
        setError,
        handleSubmit,
        getValues,
        setValue,
        clearErrors,
        formState: {errors}
    } = useForm({
        resolver: yupResolver(schema),
        mode: "onChange"
    });

    const onError = (msg, code) => {
        dispatch(onErrorAlert(msg))
        setLoading(false)
        setLoadingButtonState(false)
        setPageLoading(false)
        if (code === 401) {
            dispatch(Logout(noop))
            nav('/')
        }
    }

    const onRerender = (datax) => {
        setTotal(datax?.total ? datax?.total:0)
        setList(datax?.rows ? datax?.rows.map((item, index) => {
            return { ...item, id: uuidv4() };
        }):[])
        setPageLoading(false)
    }

    const onSubmit = (submit_data) => {
        if (checkPermission(PERMISSION_DICT.QueryOwnerInfo) && !ownerId) {
            dispatch(onErrorAlert('Owner ID is required'))
            return setError('owner', { type: 'owner', message: t('Required') })
        }

        if(!isActive){
            setError('isActive',{type:'isActive',message:t('Required')})
        }
        if(addresses.length === 0){
            dispatch(onErrorAlert(t('CustomerPage.Address is required')))
        }
        if(!isActive || addresses.length === 0){
            return null
        }
        if (customerIdError){

        }
        

        let formData = {}
        formData.customer = {}
        formData.customer.customerName = submit_data.customerName
        formData.customer.customerId = submit_data.customerId
        formData.customer.isActive = isActive ? isActive.value : ''
        formData.customer.userName = LocalStorage.getItem('username')
        formData.customer.ownerId = LocalStorage.getItem('ownerId')
        formData.addresses = []
        formData.addresses = [...addresses.map(({ addressId, ...rest }) => rest)]


        if((type === 'Add' || type === 'Copy') && customerIdError === false ){
            //admin add
            if(checkPermission(PERMISSION_DICT.QueryOwnerInfo) && ownerId?.ownerName){
                formData.customer.userName = ownerId?.ownerName
                formData.customer.ownerId = ownerId?.ownerId
            }
            setLoadingButtonState(true)
            const apiPost = async () => {
                await dispatch(addCustomer(formData,onCreateSuccess,onError))
            }
            apiPost().then()
        }

        if(type === 'Edit' && customerIdError === false ){
            formData.customer.customerId = data.customerId

            if(checkPermission(PERMISSION_DICT.QueryOwnerInfo) && ownerId?.ownerName){
                formData.customer.userName = ownerId?.ownerName
                formData.customer.ownerId = ownerId?.ownerId
            }
            setLoadingButtonState(true)
            const apiPost = async () => {
                await dispatch(editCustomer(formData,onEditSuccess,onError))
            }
            apiPost().then()
        }



    }

    const clearAllFields = () => {
        reset()
        clearErrors()
        setCustomerId('')
        setCustomerIdError(false)
        setType('Add')
        setIsActive(activeArr[0])
        setAddresses([])

    }

    const onCreateSuccess = async (msg) => {
        dispatch(onSuccessAlert(t(msg)))
        clearAllFields()
        setIsOpen(false)

        let formData = {}
        if (pageFormData) {
            formData = pageFormData
        } else {
            return nav('/')
        }


        setPageLoading(true)

        await dispatch(customerFilter(formData, onRerender, noop))

    }

    const onEditSuccess = async (msg) => {
        dispatch(onSuccessAlert(`${t('Edit')} ${msg} ${t('CustomerPage.Customer Successfully')}`))
        clearAllFields()
        setIsOpen(false)

        let formData = {}
        if (pageFormData) {
            formData = pageFormData
        } else {
            return nav('/')
        }


        setPageLoading(true)

        await dispatch(customerFilter(formData, onRerender, noop))

    }


    const handleCloseModal = ()=>{
        setOwnerId(null)
        setShowToolBar(false)
        setIsOpen(false)
        clearErrors()
        setLoadingButtonState(false)
        setAddresses([])
        setType('Add')
        // setShow(false)
        setIsActive(null)
        // setPackage(null)
        clearAllFields()

    }

    const onInfoSuccess = (data) => {
        setShowToolBar(true)
        setLoading(false)
        setAddresses([...data?.addresses])
        setValue('customerName',data.customer?.customerName)
        setValue('customerId',data.customer?.customerId)
        setCustomerId(data.customer?.customerId)
        setIsActive(activeArr.find(v=> v.value ===data.customer.isActive))
    }

    useEffect(() => {

        if(!isOpen){
            handleCloseModal()
        }

        if(type !== 'Add' && isOpen){
            const axiosPost= async () => {
                if(checkPermission(PERMISSION_DICT.QueryOwnerInfo)){
                    await dispatch(ownerSelected({condition: data?.ownerId, userName: LocalStorage.getItem('username')}, (data)=>setOwnerId(data[0])))
                }
                let formData = {}
                formData.ownerId = data.ownerId
                formData.userName = data.ownerName
                formData.customerId = data.customerId
                setLoading(true)
                await dispatch(customerInfo(formData, onInfoSuccess,onError))
            }
            axiosPost().then()
        }

    }, [isOpen])





    return(<React.Fragment>
        <Dialog
            open={isOpen}
            onClose={()=>{
                if(loadingButtonState !== true) {
                    handleCloseModal()
                }
            }}
            // onClose={handleCloseModal}
            PaperComponent={PaperComponent}
            aria-labelledby="draggable-dialog-title"
            scroll={'paper'}
            fullWidth={true}
            maxWidth={'xl'}
            sx={{
                maxHeight: "100vh", // 限制 Dialog 最大高度
                overflow: "hidden", // 避免外部滚动条
                "& .MuiDialog-paper": {
                    maxHeight: "100vh", // 让 Dialog 内部 Paper 也受限
                    overflow: "hidden", // 避免不必要的外部滚动条
                },
            }}
        >

            <MDBox component="form" role="form" onSubmit={handleSubmit(onSubmit)} noValidate sx={{maxWidth: 1300}}>
                <DialogTitle style={{ cursor: 'move', display: 'flex', justifyContent: 'space-between',alignItems: "center",
                    position: "sticky",
                    top: 0,
                    zIndex: 1100,
                    boxShadow: 'rgba(17, 17, 26, 0.05) 0px 1px 0px, rgba(17, 17, 26, 0.1) 0px 0px 8px' }}>
                    <Grid container>
                        <Grid item lg={8} md={12}>
                            <MDTypography variant={'h5'}>
                                {type === 'Add' &&<div>{t('CustomerPage.Add Customer')}</div>}
                                {type === 'Edit' &&<div>{`${t('CustomerPage.Edit Customer')} : ${data.customerId}`}</div>}
                                {type === 'Copy' &&<div>{`${t('CustomerPage.Copy Customer')} : ${data.customerId}`}</div>}
                                {type === 'Preview' &&<div>{`${t('CustomerPage.Preview Customer')} : ${data.customerId}`}</div>}

                            </MDTypography>
                        </Grid>
                        <Grid item lg={4} md={12}  sx={{width:'100%'}}>
                            <div style={{
                                display: 'flex',
                                justifyContent:'flex-end'
                            }}>
                                { type === 'Preview' && showToolBar &&
                                    <div style={{
                                        marginRight:"20px",
                                        display: 'flex',
                                        alignItems: 'center',
                                        flexDirection: 'row',
                                        justifyContent: 'flex-end'
                                    }}>
                                        {
                                            checkPermission(PERMISSION_DICT.OwnerCustomerModify) &&
                                            <Tooltip title={t('ProductPage.edit')}>
                                                <IconButton
                                                    data-test="customer-edit-btn"
                                                    color='primary'
                                                    onClick={() => {
                                                        // setTransferData(params.row);
                                                        setType('Edit');
                                                        const axiosPost = async () => {
                                                            if(checkPermission(PERMISSION_DICT.QueryOwnerInfo)){
                                                                await dispatch(ownerSelected({condition: data?.ownerId, userName: LocalStorage.getItem('username')}, (data)=>setOwnerId(data[0])))
                                                            }
                                                        }
                                                        axiosPost().then()
                                                        setType('Edit');
                                                        setIsOpen(true)
                                                    }}>
                                                    <Icon>edit</Icon>
                                                </IconButton>
                                            </Tooltip>
                                        }
                                        {
                                            checkPermission(PERMISSION_DICT.OwnerCustomerAdd) &&
                                            <Tooltip title={t('ProductPage.copy')}>
                                                <IconButton
                                                    data-test="customer-copy-btn"
                                                    color='primary'
                                                    onClick={() => {
                                                        // setTransferData(params.row);
                                                        setType('Copy');
                                                        setIsOpen(true)
                                                        setCustomerId('')
                                                        setValue('customerId','')
                                                    }}>
                                                    <Icon>copy</Icon>
                                                </IconButton>
                                            </Tooltip>
                                        }

                                    </div>

                                }
                                <IconButton size="medium"
                                            onClick={()=>{
                                                if(loadingButtonState !== true) {
                                                    handleCloseModal()
                                                }
                                            }}
                                    // onClick={() => setIsOpen(false)}
                                >
                                    <Icon>cancel</Icon>
                                </IconButton>
                            </div>

                        </Grid>
                    </Grid>


                </DialogTitle>
                <DialogContent sx={{
                    maxHeight: "80vh", // 限制最大高度，防止 Dialog 过长
                    overflowY: "auto", // 允许滚动
                }} >
                    <DialogContentText>
                        <MDBox pt={2} pb={2} px={3} sx={{display: 'flex', justifyContent: 'space-between',flexDirection:'column'}}>

                            <Grid container spacing={2} sx={{display:'flex', alignItems:'flex-start'}}>
                                    <Grid item xs = {12} md={12} mb={2} sx={{display:'flex', alignItems:'center',justifyContent:'center'}}>

                                        <Avatar  sx={darkMode?{bgcolor:'whitesmoke'}:{bgcolor:'#7b809a'}}>
                                            <Icon>person_add</Icon>
                                        </Avatar>
                                    </Grid>
                                {
                                    checkPermission(PERMISSION_DICT.QueryOwnerInfo) &&
                                    <Grid item xs={12} md={6} mb={2} sx={{ minWidth: { xs: 250, md: 350 } }}>
                                        <FormControl fullWidth error={!!errors.owner}>
                                            <Autocomplete
                                                required
                                                disablePortal={false}
                                                options={ownerList}
                                                // readOnly={type === 'Preview'}
                                                disabled={type === "Edit" || type === "Copy"||type === 'Preview' }
                                                getOptionLabel={(option) => `ID: ${option?.ownerId} Name: ${option?.ownerName}`}
                                                isOptionEqualToValue={(option, value) => option?.ownerId === value?.ownerId}
                                                value={ownerId}
                                                onChange={(e, v) => setOwnerId(v)}
                                                onInputChange = {(event, newInputValue)=> setInputOwnerValue(newInputValue)}
                                                renderInput={(params) =>
                                                    <MDInput
                                                        data-test="customer-owner-autocomplete-input"
                                                        {...params}
                                                        label={t('Owner ID or Name')}
                                                        required
                                                        InputLabelProps={{ shrink: true }}
                                                    />}
                                                noOptionsText={t('No Options')}
                                            />
                                            <FormHelperText
                                                sx={{ fontWeight: 'medium' }}>{errors?.owner?.message}</FormHelperText>
                                        </FormControl>
                                    </Grid>
                                }
                                <Grid item xs={12} md={6} mb={2} sx={{ minWidth: { xs: 250, md: 350 } }}>
                                    <FormControl
                                        error={!!errors.customerId}
                                        fullWidth
                                        required
                                    >
                                        <MDInput
                                            data-test="customer-id-input"
                                            label={t('CustomerPage.Customer ID')}
                                            fullWidth
                                            required
                                            disabled={type === 'Preview' || type === 'Edit'}
                                            {...register("customerId")}
                                            error={!!errors?.customerId}
                                            minLength={300}
                                            InputLabelProps={{shrink: true}}
                                            value={customerId}
                                            onChange={(e) => setCustomerId(e.target.value)}
                                        />
                                        <FormHelperText
                                            sx={{fontWeight: 'medium'}}>{errors?.customerId?.message}</FormHelperText>
                                    </FormControl>
                                </Grid>
                                    <Grid item xs={12} md={6} mb={2} sx={{ minWidth: { xs: 250, md: 350 } }}>
                                        <FormControl
                                            error={!!errors.customerName}
                                            fullWidth
                                            required
                                        >
                                            <MDInput
                                                label={t('CustomerPage.Customer Name')}
                                                fullWidth
                                                required
                                                disabled={type === 'Preview'}
                                                {...register("customerName")}
                                                error={!!errors?.customerName}
                                                minLength={300}
                                                InputLabelProps={{shrink: true}}
                                            />
                                            <FormHelperText
                                                sx={{fontWeight: 'medium'}}>{errors?.customerName?.message}</FormHelperText>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} md={6} mb={2} sx={{ minWidth: { xs: 250, md: 350 } }}>
                                        <FormControl fullWidth required
                                                     error={!!errors?.isActive} {...register('isActive')}>
                                            <Autocomplete
                                                required
                                                error={!!errors?.isActive}
                                                disabled={type ==='Preview'}
                                                readOnly={type ==='Preview' || type === 'Add' || type === 'Copy'}
                                                {...register('isActive')}
                                                disablePortal={false}
                                                options={
                                                    activeArr
                                                }
                                                getOptionLabel={(option) => `${option?.label}`}
                                                isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                                value={isActive}
                                                onChange={(e, v) => {
                                                    setIsActive(v)
                                                }}
                                                renderInput={(params) =>
                                                    <MDInput
                                                        required
                                                        {...register('isActive')}
                                                        {...params}
                                                        label={t("ProductPage.isActive")}
                                                        InputLabelProps={{shrink: true}}
                                                        error={!!errors?.isActive}

                                                    />}
                                            />
                                            <FormHelperText
                                                sx={{fontWeight: 'medium'}}>{errors?.isActive?.message}</FormHelperText>
                                        </FormControl>

                                    </Grid>
                            </Grid>


                            <Grid container spacing={2} sx={{display:'flex', alignItems:'center'}}>
                                <Grid item xs={12}>
                                    <MDTypography variant={'h6'}>{t('CustomerPage.Manage Addresses')}</MDTypography>
                                </Grid>
                                <Grid item container spacing={1} xs={12}>
                                    {addresses.sort((a, b) => {
                                        if (a.isDefault === 'Y' && b.isDefault !== 'Y') {
                                            return -1; // 如果a.isDefault为'Y'，而b.isDefault不是'Y'，则a排在b前面
                                        } else if (a.isDefault !== 'Y' && b.isDefault === 'Y') {
                                            return 1; // 如果b.isDefault为'Y'，而a.isDefault不是'Y'，则b排在a前面
                                        } else {
                                            return 0; // 其他情况保持原顺序
                                        }
                                    }).map((v,i)=>
                                        <Grid item key={v?.i} xs={12}>
                                            <MDBox>
                                                <AddressGrid address={v} setCurrentAddress={setCurrentAddress} setAddresses={setAddresses} setMode={setMode} type={type}/>
                                            </MDBox>
                                        </Grid>
                                    )}
                                </Grid>
                                {
                                    type !== 'Preview' &&
                                    <Grid item xs={12}>
                                        <MDButton
                                            variant="outlined"
                                            color="primary"
                                            disabled={
                                                (type === 'Edit' && !(checkPermission(PERMISSION_DICT.OwnerCustomerModify)&&checkPermission(PERMISSION_DICT.OwnerCustomerAddAddress))) ||
                                                ((type === 'Add' || type === 'Copy') && !(checkPermission(PERMISSION_DICT.OwnerCustomerAdd)&&checkPermission(PERMISSION_DICT.OwnerCustomerAddAddress)))
                                            } onClick={()=>setIsAddressOpen(true)}
                                        >
                                            {t('CustomerPage.Add New Address')}
                                        </MDButton>
                                    </Grid>
                                }

                            </Grid>
                        </MDBox>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button disabled={loadingButtonState} onClick={() => {
                        setOwnerId(null)
                        setIsOpen(false)
                    }}>
                        {t(`Cancel`)}
                    </Button>
                    {
                        type !== 'Preview' && <Button
                            data-test="customer-submit-btn"
                            loading={loadingButtonState}
                            type={'submit'}
                            disabled={customerIdError}>
                            {t('Submit')}
                        </Button>
                    }

                </DialogActions>
            </MDBox>
        </Dialog>
        <AddressAdd isAddressOpen={isAddressOpen}
                    setIsAddressOpen={setIsAddressOpen}
                    addresses={addresses}
                    setAddresses={setAddresses}
                    currentAddress={currentAddress}
                    setCurrentAddress = {setCurrentAddress}
                    setMode={setMode}
                    mode = {mode}
                    customerId={data?.customerId}
                    ownerId={data?.ownerId}
                    customerName={data?.customerName}
                    type={type}
        />
    </React.Fragment>)
}

export default CustomerEditor